export default __webpack_public_path__ + "static/healthcare-page-resource-img-1-73ece59911858ae57d5e66d8c2958f03.png";